// Font Families
export const fontFamilyDefault = 'RakutenSansUi';
export const fontFamilyBranding = 'RakutenSansUi, serif';
export const fontFamilyItalic = 'RakutenSansUi';
// Font Weights
export const weightRegular = 400;
export const weightSemibold = 600;
// Font Sizes
export const fontSizeDisplay1 = '48px';
export const fontSizeDisplay2 = '40px';
export const fontSizeDisplay3 = '32px';
export const fontSizeH1 = '24px';
export const fontSizeH2 = '20px';
export const fontSizeH3 = '18px';
export const fontSizeH4 = '16px';
export const fontSizeBodyDefault = '14px';
export const fontSizeBodySmall = '12px';
export const fontSizeBodyTiny = '10px';
// Line Heights
export const lineHeightDisplay1 = '52px';
export const lineHeightDisplay2 = '40px';
export const lineHeightDisplay3 = '48px';
export const lineHeightH1 = '32px';
export const lineHeightH2 = '28px';
export const lineHeightH3 = '24px';
export const lineHeightH4 = '20px';
export const lineHeightBodyDefault = '18px';
export const lineHeightBodySmall = '14px';
export const lineHeightBodyTiny = '12px';
// Letter Spacing
export const letterSpacingDefault = '0px';
// Scale
export const scale1400 = '52px';
export const scale1300 = '48px';
export const scale1200 = '44px';
export const scale1100 = '40px';
export const scale1000 = '36px';
export const scale900 = '32px';
export const scale800 = '28px';
export const scale700 = '24px';
export const scale600 = '20px';
export const scale500 = '18px';
export const scale400 = '16px';
export const scale300 = '14px';
export const scale200 = '12px';
export const scale100 = '10px';
export const scale0 = '0px';
